module.exports = __webpack_public_path__ + "static/media/407JamesPBrawleyDrNW_2018-06-12_78.9d9578d2.jpg";